// -*- Mode: rjsx -*-
import React from 'react';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FHMaterialStyles } from "../../../ui/fh-material-styles.js";

function Flag(props) {
    const classes = FHMaterialStyles();
    const request = props.request;
    function handleChange() {
    }

    return (
        <a href={"/admin/request/" +  request.key}>Switch to Classic View</a>
    );
    
    return (
        <FormControl
          variant="filled"
          className={classes.settingsFormControl}
          style={{minWidth: 150, paddingRight: 16 }}>
          <InputLabel id="flag-task-select-label">Flag task as ...</InputLabel>
          <Select
            labelId="flag-task-label"
            id="flag-task-select"
            onChange={handleChange}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            <MenuItem value={10}>Ten</MenuItem>
            <MenuItem value={20}>Twenty</MenuItem>
            <MenuItem value={30}>Thirty</MenuItem>
          </Select>
        </FormControl>
    );
}


export { Flag };
